import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import DataEmbarcadorTable from "../../components/Data-embarcador-table/data-embarcador-table";
import AddIcon from '@mui/icons-material/Add';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { cardIconSx, clientListThemeVars } from "../../theme/globalStyle/globalStyle";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import './embarcador.css';
require('firebase/auth')

function EmbarcadorList(){

    
    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)
    const canCreateEmbarcador = user?.permissoes?.shipper?.isCreate || user?.permissoes?.empresa?.cadastrar;  
    const [cleanFilters, setCleanFilters] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

  
    return(

        <>

            { 
                
    userLogado > 0 ?
                    <NewMiniDrawer divOpen={
                        
                        <Box className="embarcador-list-page" sx={pageWrapperSx} style={clientListThemeVars}>
                                <Card sx={heroCardSx}>
                                 <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                     <Box className="embarcador-list-hero">
                                         <Stack spacing={1} className="embarcador-list-hero-copy">
                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                 <Box sx={cardIconSx}>
                                                     <Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />
                                                 </Box>
                                                 <Typography sx={heroTitleSx}>Empresas</Typography>
                                             </Box>
                                             <Typography sx={heroSubtitleSx}>
                                                 Consulte, filtre e mantenha as Empresas usadas nas operacoes comerciais e de transporte.
                                             </Typography>
                                         </Stack>

                                         <Stack direction="row" spacing={1.5}>
                                             {canCreateEmbarcador ? (
                                                 <Button
                                                     component={Link}
                                                     to="/newEmbarcador"
                                                     variant="contained"
                                                     startIcon={<AddIcon />}
                                                     sx={primaryActionSx}
                                                 >
                                                     Nova Empresa
                                                 </Button>
                                             ) : null}

                                             <Button
                                                 variant="outlined"
                                                 sx={secondaryActionSx}
                                                 onClick={() => setCleanFilters(!cleanFilters)}
                                             >
                                                 Limpar Filtros
                                             </Button>

                                             <Button
                                                 variant="contained"
                                                 sx={highlightActionSx}
                                                 onClick={() => setOpenFilters(!openFilters)}
                                             >
                                                 Filtros Salvos
                                             </Button>
                                         </Stack>
                                     </Box>
                                 </CardContent>
                             </Card>

                             <Card sx={contentCardSx}>
                                 <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                                     <Box className="embarcador-list-table-heading">
                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                             <Box sx={cardIconSx}>
                                                 <TableRowsOutlinedIcon sx={{ color: "#ffffff" }} />
                                             </Box>
                                             <Box>
                                                 <Typography sx={sectionTitleSx}>Lista de empresa</Typography>
                                                 <Typography sx={sectionSubtitleSx}>Use os filtros das colunas para localizar registros especificos.</Typography>
                                             </Box>
                                         </Box>
                                     </Box>
 
                                     <Box className="embarcador-list-table-shell">
                                         <DataEmbarcadorTable
                                             cleanFilters={cleanFilters}
                                             openFilters={openFilters}
                                             onCleanFilterHandled={() => setCleanFilters(false)}
                                             onOpenFilterHandled={() => setOpenFilters(false)}
                                         />
                                     </Box>
                                 </CardContent>
                             </Card>
                         </Box>
                 }/>
                :
                <Navigate to='/login' />
            }

        </>

    );
}

export default EmbarcadorList;

const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};


const secondaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  color: "var(--client-primary)",
  borderColor: "var(--client-primary-border)",
  "&:hover": {
    borderColor: "var(--client-primary)",
    backgroundColor: "var(--client-primary-soft)",
  },
};

const highlightActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-highlight)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "#e02c00",
    },
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-soft)",
};

const heroTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--client-primary-hover)",
    },
};

const contentCardSx = {
    borderRadius: "var(--client-radius-lg)",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-table)",
    background: "var(--client-surface-soft)",
};

const sectionTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};
